// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ConsoleSqlOutlinedSvg from "@fishx/icons-svg/es/asn/ConsoleSqlOutlined";
import FishxIcon from '../components/FishxIcon';

var ConsoleSqlOutlined = function ConsoleSqlOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ConsoleSqlOutlinedSvg
  }));
};

ConsoleSqlOutlined.displayName = 'ConsoleSqlOutlined';
export default React.forwardRef(ConsoleSqlOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ConsoleSqlOutlined.js
// module id = 2301
// module chunks = 0